import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';

@Component({
  selector: 'app-notification-view',
  templateUrl: './notification-view.component.html',
  styleUrls: ['./notification-view.component.css']
})
export class NotificationViewComponent implements OnInit {
  @Input() notificationList;
  @Input() modelHeader;
  licensePlateClass: string;
  constructor(
    public activeModal: NgbActiveModal,
    private globalSetting: GlobalSetting
    ) { }

  ngOnInit(): void {
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
  }

}
